module.exports = __webpack_public_path__ + "img/schedule-service-bar-chevy.220a941d.png";